import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { useLenis } from "@/hooks/useLenis";
import { ModalProvider } from "@/components/site/Forms";
import { Navbar } from "@/components/site/Navbar";
import { Footer } from "@/components/site/Footer";
import { AIAssistant } from "@/components/site/AIAssistant";
import { FloatingCTAs, MobileBottomCTA } from "@/components/site/FloatingCTAs";
import { CookieConsent } from "@/components/site/CookieConsent";
import Home from "@/pages/Home";
import BlogList from "@/pages/BlogList";
import BlogPost from "@/pages/BlogPost";
import CaseStudy from "@/pages/CaseStudy";
import AdminDashboard from "@/pages/AdminDashboard";

function App() {
  useLenis();
  return (
    <div className="App min-h-screen bg-ink-0">
      <BrowserRouter>
        <ModalProvider>
          <Navbar />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/insights" element={<BlogList />} />
            <Route path="/insights/:slug" element={<BlogPost />} />
            <Route path="/case-studies/:slug" element={<CaseStudy />} />
            <Route path="/admin" element={<AdminDashboard />} />
            <Route
              path="*"
              element={
                <main className="flex min-h-screen flex-col items-center justify-center bg-ink-0 px-5 text-center" data-testid="not-found-page">
                  <p className="font-mono text-xs uppercase tracking-[0.3em] text-brand-cyan">404</p>
                  <h1 className="mt-4 font-display text-4xl font-bold text-white sm:text-5xl lg:text-6xl">Page not found.</h1>
                  <a href="/" className="mt-8 inline-flex items-center gap-2 rounded-full border border-white/15 bg-white/5 px-7 py-3.5 font-medium text-white transition-colors hover:border-brand-cyan/50">Back to Home</a>
                </main>
              }
            />
          </Routes>
          <Footer />
          <AIAssistant />
          <FloatingCTAs />
          <MobileBottomCTA />
          <CookieConsent />
        </ModalProvider>
      </BrowserRouter>
      <Toaster position="top-center" theme="dark" richColors />
    </div>
  );
}

export default App;
